<!--begin::Authentication - -->
<div class="d-flex flex-column flex-center flex-column-fluid">
  <!--begin::Content-->
  <div class="d-flex flex-column flex-center text-center p-10">
    <!--begin::Wrapper-->
    <div class="card card-flush  w-lg-650px py-5">
      <div class="card-body py-15 py-lg-20">
        <router-outlet></router-outlet>
      </div>
    </div>
    <!--end::Wrapper-->
  </div>
  <!--end::Content-->
</div>
<!--end::Authentication - -->
